import { render, staticRenderFns } from "./Clients_group_op.vue?vue&type=template&id=54a24fbd&scoped=true"
import script from "./Clients_group_op.vue?vue&type=script&lang=js"
export * from "./Clients_group_op.vue?vue&type=script&lang=js"
import style0 from "./Clients_group_op.vue?vue&type=style&index=0&id=54a24fbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a24fbd",
  null
  
)

export default component.exports